import React from "react";
import { useNavigate } from "react-router-dom";
import { Menu, Transition } from "@headlessui/react";
import { mdiChevronLeft, mdiSortVariant } from "@mdi/js";
import Icon from "@mdi/react";
import clsx from "clsx";

import { ORDER_LIST } from "constants/base";
import styles from "./style.module.scss";

type CustomHeaderProps = {
  title: string;
  orderList: any[];
  selectedOrder: string;
  setSelectedOrder: (order: string) => void;
};

export default function ListPageMobileHeader({
  title,
  orderList,
  selectedOrder,
  setSelectedOrder
}: Readonly<CustomHeaderProps>) {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className={styles.headerContainer}>
      <div className="flex items-center">
        <button onClick={goBack}>
          <Icon path={mdiChevronLeft} className="size-8" />
        </button>
        <h4 className={styles.title}>{title}</h4>
      </div>

      <Menu as="div" className={styles.menuWrapper}>
        <Menu.Button className="bg-transparent">
          <Icon path={mdiSortVariant} />
        </Menu.Button>

        <Transition
          as={React.Fragment}
          enter="transition ease-out duration-300"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95">
          <Menu.Items className={styles.menu}>
            {(orderList ?? ORDER_LIST).map((item) => (
              <Menu.Item key={item.id}>
                <button
                  className={clsx(styles.item, {
                    "text-primary": item.value === selectedOrder
                  })}
                  onClick={() => setSelectedOrder(item.value)}>
                  {item.name}
                </button>
              </Menu.Item>
            ))}
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}
